import { ApplyPureFunctionPipe } from '@/utils/angular/pipes/apply-pure-function.pipe';
import { NgStyle } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractTailoredTemplateWidget } from '../AbstractTailoredWidgetTemplate.class';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./template-widget-custom-image-base64.scss'],
    selector: 'template-widget-custom-image-base64',
    templateUrl: 'template-widget-custom-image-base64.html',
    imports: [NgStyle, ApplyPureFunctionPipe]
})
export class TemplateWidgetCustomImageBase64Component extends AbstractTailoredTemplateWidget<{
    image: string;
    displayType?: string;
    backgroundColor?: string;
}> {
    getImageBase64(image: string): string {
        return JSON.parse(image).base64;
    }
}
